var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "区域代理",
        visible: _vm.dialogVisible,
        width: "60%",
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            "max-height": "50vh",
            "overflow-y": "auto",
            padding: "15px 30px",
            "background-color": "#f6f6f6"
          }
        },
        [
          _c(
            "el-form",
            { ref: "form", attrs: { model: _vm.form, "label-width": "120px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "会员编号" } },
                [
                  _c(
                    "el-row",
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.user_number,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "user_number", $$v)
                          },
                          expression: "form.user_number"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "选择区域" } },
                [
                  _vm.isShowInfo
                    ? _c("el-cascader", {
                        ref: "cascaderRef",
                        attrs: { filterable: "", props: _vm.props },
                        on: { change: _vm.areaChange },
                        model: {
                          value: _vm.form.area,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "area", $$v)
                          },
                          expression: "form.area"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "申请日期" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "date",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      placeholder: "选择日期"
                    },
                    model: {
                      value: _vm.form.create_at,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "create_at", $$v)
                      },
                      expression: "form.create_at"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "审核状态" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "220px" },
                      attrs: { size: "mini" },
                      model: {
                        value: _vm.form.status,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "status", $$v)
                        },
                        expression: "form.status"
                      }
                    },
                    [
                      _c("el-option", { attrs: { value: 0, label: "待初审" } }),
                      _c("el-option", {
                        attrs: { value: 1, label: "初审通过" }
                      }),
                      _c("el-option", {
                        attrs: { value: -1, label: "初审拒绝" }
                      }),
                      _c("el-option", { attrs: { value: 2, label: "待终审" } }),
                      _c("el-option", {
                        attrs: { value: 3, label: "终审通过" }
                      }),
                      _c("el-option", { attrs: { value: 4, label: "冻结中" } })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "赛道" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      on: { change: _vm.handleChange },
                      model: {
                        value: _vm.form.track,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "track", $$v)
                        },
                        expression: "form.track"
                      }
                    },
                    _vm._l(_vm.tracks, function(item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.value, value: item.key }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.dialogVisible = false
                }
              }
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.clickSubmit } },
            [_vm._v("提交")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }